/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_UsInputs */

const en_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

const th_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเรา`)
};

const ja_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const fr_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous contacter`)
};

const es_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const ru_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться с нами`)
};

const zh_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const vi_contact_us = /** @type {(inputs: Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Contact_UsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const contact_us = /** @type {((inputs?: Contact_UsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_UsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_contact_us(inputs)
	if (locale === "ja") return ja_contact_us(inputs)
	if (locale === "fr") return fr_contact_us(inputs)
	if (locale === "es") return es_contact_us(inputs)
	if (locale === "ru") return ru_contact_us(inputs)
	if (locale === "zh") return zh_contact_us(inputs)
	if (locale === "vi") return vi_contact_us(inputs)
	return en_contact_us(inputs)
});